import request from '@/utils/request'


// 查询充值订单列表
export function listRechargeOrder(query) {
  return request({
    url: '/golf/golf-recharge-order/list',
    method: 'get',
    params: query
  })
}

// 查询充值订单分页
export function pageRechargeOrder(query) {
  return request({
    url: '/golf/golf-recharge-order/page',
    method: 'get',
    params: query
  })
}

// 查询充值订单详细
export function getRechargeOrder(data) {
  return request({
    url: '/golf/golf-recharge-order/detail',
    method: 'get',
    params: data
  })
}

// 新增充值订单
export function addRechargeOrder(data) {
  return request({
    url: '/golf/golf-recharge-order/add',
    method: 'post',
    data: data
  })
}

// 修改充值订单
export function updateRechargeOrder(data) {
  return request({
    url: '/golf/golf-recharge-order/edit',
    method: 'post',
    data: data
  })
}

// 删除充值订单
export function delRechargeOrder(data) {
  return request({
    url: '/golf/golf-recharge-order/delete',
    method: 'post',
    data: data
  })
}
